var _defs, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTooth16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 98.17 141.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m48.04,55.26c-9.37,0-9.37-7.03-11.72-23.43-.73-5.08-1.45-9.26-2.11-12.61,1.79-5.98,4.29-11.92,6.79-13.17,4.69-2.34,14.06,14.06,14.06,18.75,0,2.17,1.51,7.34,3.12,12.28-.47,3.36-.78,5.86-.78,6.46,0,2.34,0,11.72-9.37,11.72Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m62.1,10.74s-4.69,30.46-4.69,32.81c0,2.34,0,11.72-9.37,11.72s-9.37-7.03-11.72-23.43c-2.34-16.4-4.69-23.43-4.69-23.43,0,0-4.69-7.03-11.72-2.34-7.03,4.69-9.37,25.78-9.37,35.15,0,9.37,2.34,25.78,0,30.46-2.34,4.69-9.37,28.12-9.37,39.84,0,11.72,9.37,32.81,25.78,28.12,16.4-4.69,18.75-7.03,28.12-4.69,9.37,2.34,32.81,7.03,37.5-4.69s7.03-28.12,0-42.18c-7.03-14.06-7.03-44.53-7.03-56.24,0-11.72-9.37-30.46-16.4-30.46,0,0-7.03-2.34-7.03,9.37Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m77.33,119.71s-17.58,3.52-26.95-5.86"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m52.73,127.91s0-7.03-7.03-7.03-14.06,2.34-18.75,2.34"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m78.51,76.35s-37.5-16.4-58.59,2.34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooth16);
export default __webpack_public_path__ + "static/media/tooth-16.bfe0c26b814f98471897238ffcac883e.svg";
export { ForwardRef as ReactComponent };